import { render } from "./JournalPreviewBlocks.vue?vue&type=template&id=304146c2&scoped=true"
import script from "./JournalPreviewBlocks.vue?vue&type=script&lang=js"
export * from "./JournalPreviewBlocks.vue?vue&type=script&lang=js"

import "./JournalPreviewBlocks.vue?vue&type=style&index=0&id=304146c2&scoped=true&lang=css"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304146c2"]])

export default __exports__